module.exports = __webpack_public_path__ + "img/bianjie5.c0e3e250.png";